<ng-container *ngIf="loading$ | async">
    <app-loader></app-loader>
</ng-container>

<ng-container *ngIf="!(loading$ | async)">
    <div class="page-wrapper">
        <div class="stepper">
            <app-wizard-stepper *ngIf="stepperTexts"
                                [stepTextGapOff]="false"
                                [titleList]="stepperTexts"
                                [numberOfSteps]="numberOfWizardSteps"
                                [wizardStep]="stepNo">
            </app-wizard-stepper>
        </div>

        <div class="header">
            <app-header
                    [tabIndex]="-1"
                    [ttsIconState]="ttsIconState"
                    [repeatButtonDisabled]="repeatButtonDisabled"
                    [showHeaderControls]="showHeaderControls"
                    [leaveButton]="true"
                    [leaveButtonLabel]="'GENERAL.LOGOUT' | translate"
                    [backButtonDisplayed]="true"
                    [backButtonLabel]="'GENERAL.BACK' | translate"
                    [headerText]="headerInfo.wizardStepHeader"
                    [headerParagraph]="headerInfo.wizardStepParagraph"
                    [showActionButton]="showHeaderButton"
                    [actionButtonText]="headerButtonText"
                    (playFromStartAudioEvent)="play()"
                    (readTextEvent)="readText()"
                    (leaveIndication)="onLogOut()"
                    (buttonEvent)="stepBackButtonEvent()">
            </app-header>
        </div>

        <div role="main" class="content">
            <app-wizard-language-style *ngIf="wizardStepEnum !== undefined && wizardStepEnum === wsLanguageStyle"
                                       [isAudioMode]="autoPlayVoice"
                                       [easyLanguageStyleVisible]="easyLanguageStyleVisible"
                                       (nextStepEvent)="languageStyleSelected($event)">
            </app-wizard-language-style>
            <app-wizard-presentation-mode *ngIf="wizardStepEnum !== undefined && wizardStepEnum === wsPresentationMode"
                                          (nextStepEvent)="presentationModeSelected($event)">
            </app-wizard-presentation-mode>
            <app-wizard-step-indications *ngIf="wizardStepEnum !== undefined && wizardStepEnum === wsIndications"
                                         [indications]="indications$ | async"
                                         (indicationSelectedClickEvent)="indicationFullSelected($event)"
                                         (nextStepEvent)="indicationSelected($event)">

            </app-wizard-step-indications>
            <app-wizard-step-consent-use-cases *ngIf="wizardStepEnum !== undefined && wizardStepEnum === wsUseCases && !useCaseDetailsShow"
                                               [consentUseCases]="consentUseCases$ | async"
                                               [customUseCasesVisible]="customUseCasesVisible"
                                               (useCaseStepEvent)="useCaseSelected($event)"
                                               (myUseCaseEvent)="customUseCaseSelected($event)">
            </app-wizard-step-consent-use-cases>
            <app-wizard-step-consent-use-case-details *ngIf="wizardStepEnum !== undefined && wizardStepEnum === wsUseCases && useCaseDetailsShow"
                                                      [selectedUseCaseId]="selectedUseCaseId"
                                                      [consentUseCases]="consentUseCases$ | async"
                                                      [durationInMillis]="durationInMillis$  | async"
                                                      [initialUseCaseDetails]="consentUseCaseDetails"
                                                      (useCaseChapterChange)="chapterUseCaseChanged($event)"
                                                      (provisionDurationChange)="provisionDurationChanged($event)"
                                                      (nextStepEvent)="useCaseDetailsSelected()">
            </app-wizard-step-consent-use-case-details>
        </div>
    </div>
</ng-container>
